export enum Method {
  Z_TEST = 'Z_TEST',
  GST_Z_TEST = 'GST_Z_TEST',
  ASYMP_CS = 'ASYMP_CS',
  RATIO = 'RATIO',
  GST_RATIO = 'GST_RATIO',
  ASYMP_CS_RATIO = 'ASYMP_CS_RATIO',
  UNKNOWN = 'UNKNOWN',
}

export enum MetricDirection {
  METRIC_DIRECTION_UNSPECIFIED = 'METRIC_DIRECTION_UNSPECIFIED',
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
}
